const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function api(path, { method = "GET", body } = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    credentials: "include",
    headers: body ? { "Content-Type": "application/json" } : {},
    body: body ? JSON.stringify(body) : undefined,
  });
  if (res.status === 401) {
    const err = new Error("Non authentifié");
    err.status = 401;
    throw err;
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.detail || "Une erreur est survenue");
    err.status = res.status;
    throw err;
  }
  return data;
}

export function downloadUrl(path) {
  return `${API}${path}`;
}

export async function apiUpload(path, formData, method = "POST") {
  const res = await fetch(`${API}${path}`, {
    method,
    credentials: "include",
    body: formData,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.detail || "Une erreur est survenue");
    err.status = res.status;
    throw err;
  }
  return data;
}
